import script from "./BVImain.vue?vue&type=script&setup=true&lang=js"
export * from "./BVImain.vue?vue&type=script&setup=true&lang=js"

import "./BVImain.vue?vue&type=style&index=0&id=05d03fac&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d03fac"]])

export default __exports__